module.exports = __webpack_public_path__ + "img/contacts_empty.5289f7cb.svg";